import React from 'react';
import {
  Calculator, Scale, Building2, Landmark, Users, FileText, Plane, Ship,
  BadgeCheck, Layers, Award, Heart, ShieldCheck, PiggyBank,
} from 'lucide-react';

const MAP = {
  Calculator, Scale, Building2, Landmark, Users, FileText, Plane, Ship,
  BadgeCheck, Layers, Award, Heart, ShieldCheck, PiggyBank,
};

export default function ServiceIcon({ name, className = 'w-6 h-6', strokeWidth = 1.6 }) {
  const Ic = MAP[name] || FileText;
  return <Ic className={className} strokeWidth={strokeWidth} />;
}
